// extracted by mini-css-extract-plugin
export default {"root":"cookie-module__root--jAxwO","text":"cookie-module__text--Xz5us"};